export const alternativesQualityContract = {
  minAlternativeCount: 5,
  minReasonCodeCount: 2,
  requiredContrastFields: ["pricingContrast", "licenseContrast", "featureContrast"],
  // Quick answer summary cap: keeps the lead paragraph scannable instead of a
  // run-on list of every alternative (the cards already enumerate them).
  maxSummaryLength: 260,
} as const

// Four reviewed SERP products provide three direct substitutes. Do not pad
// these comparisons with independent web indexes or general scraping APIs.
export const minimumAlternativesBySource: Readonly<Record<string, number>> = {
  serpapi: 3,
  dataforseo: 3,
}

export const alternativesDemandSlugs = [
  "playwright",
  "selenium",
  "puppeteer",
  "apify",
  "firecrawl",
  "scrapingbee",
  "scraperapi",
  "oxylabs",
  "dataforseo",
  "serpapi",
  "browserless",
  "crawl4ai",
  "scrapegraphai",
  "zyte-api",
  "zenrows",
  "scrapfly",
  "browserbase",
  "diffbot",
  "browse-ai",
  "octoparse",
  "parsehub",
] as const

export const alternativeReasonCodes = [
  "better-for-ai-workflows",
  "browser-rendering",
  "managed-api",
  "open-source",
  "pricing-fit",
  "proxy-network",
  "self-hosted",
  "serp-focused",
] as const

export const alternativeReasonLabels = {
  "better-for-ai-workflows": "AI workflows",
  "browser-rendering": "browser rendering",
  "managed-api": "managed API",
  "open-source": "open source",
  "pricing-fit": "pricing fit",
  "proxy-network": "proxy network",
  "self-hosted": "self-hosted",
  "serp-focused": "SERP focused",
} as const satisfies Record<(typeof alternativeReasonCodes)[number], string>

export type AlternativesDemandSlug = (typeof alternativesDemandSlugs)[number]
export type AlternativeReasonCode = (typeof alternativeReasonCodes)[number]
